"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.string.trim.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeNonHTMLInput = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
var sanitizeNonHTMLInput = exports.sanitizeNonHTMLInput = function sanitizeNonHTMLInput(input) {
  return (_dompurify.default.sanitize(input, {
    RETURN_DOM: true
  }).textContent || '').trim();
};
//# sourceMappingURL=sanitize.js.map